import ApplicationController from "../../application_controller.js";
import Toast from "bootstrap/js/dist/toast";

export default class extends ApplicationController  {
  debug = false;

  connect() {
    this.log_function("connect");

    this.toastInstance = Toast.getOrCreateInstance(this.element);
    this.toastInstance.show();
  }

  disconnect(){
    this.log_function("disconnect");

    this.toastInstance.dispose();
  }
}
